import useQProfile from "../queries/useQProfile";
import {EnumModules} from "../resources/IProfile.resource";

interface IModuleAccess {
    isLoading: boolean;
    hasAccess: boolean;
}

const useHasChecklistManagementAccess = (): IModuleAccess => {
    const {profile, isLoading} = useQProfile();

    return {
        isLoading,
        hasAccess: profile?.modules.includes(EnumModules.CHECKLIST_MANAGEMENT) ?? false,
    };
};

export default useHasChecklistManagementAccess;
